import request from '@/utils/request'

export function getLegalDocumentList(params = {}) {
  return request.get('/legal/admin/documents', params)
}

export function getLegalDocumentDetail(id) {
  return request.get('/legal/admin/documents/detail', { id })
}

export function createLegalDocument(data) {
  return request.post('/legal/admin/documents/create', data)
}

export function updateLegalDocument(data) {
  return request.post('/legal/admin/documents/update', data)
}

export function publishLegalDocument(id, isCurrent) {
  return request.post('/legal/admin/documents/publish', {
    id,
    is_current: Boolean(isCurrent)
  })
}

export function offlineLegalDocument(id) {
  return request.post('/legal/admin/documents/offline', { id })
}

export function setCurrentLegalDocument(id) {
  return request.post('/legal/admin/documents/set-current', { id })
}
